import { useCallback, useRef, useState } from 'react';
import useEventListener from './eventListener';

interface Size {
  width: number;
  height: number;
}

function useElementSize<T extends HTMLElement = HTMLDivElement>(): [
  React.RefObject<T>,
  Size,
] {
  const ref = useRef<T>(null);

  const [size, setSize] = useState<Size>({
    width: 0,
    height: 0,
  });

  const handleSize = useCallback(() => {
    if (ref.current == null) return;

    setSize({
      width: ref.current.offsetWidth || 0,
      height: ref.current.offsetHeight || 0,
    });
  }, [setSize]);

  useEventListener('resize', handleSize, undefined, true);

  return [ref, size];
}

export default useElementSize;
